import { takeLatest, put, call } from 'redux-saga/effects';

import {
  OPEN_PLATFORM_MY_APP_PAGE_REQUEST,
  OPEN_PLATFORM_MY_APP_LIST_REQUEST,
  OPEN_PLATFORM_MY_APP_ON_CANCEL_REMOVE_APP,
  OPEN_PLATFORM_MY_APP_ON_CONFIRM_REMOVE_APP,
  OPEN_PLATFORM_MY_APP_ON_CLICK_REMOVE_APP,
} from '../../actions/openPlatform/myApp/constants';
import { showProgressBar, hideProgressBar } from '../../actions';
import * as actNotif from '../../actions/notifications';
import * as actMyApp from '../../actions/openPlatform/myApp';

import * as apiAuthorizedApps from '../../api/backoffice/authorizedApps';
import * as apiProfile from '../../api/profile';
import * as apiPartners from '../../api/partner';
import { hasFeature } from '../../utils/featureFlags';
import { assertErrorHasMessage } from '../../utils/assert';
import * as clevertapOpenPlatformMyApp from '../../clevertap/openPlatform/myApp';
import * as partnerDTOHelper from '../partner/Dto/DtoHelper';

export function* listRequest(request) {
  const {
    payload: { userId },
  } = request;
  try {
    yield put(showProgressBar());
    yield put(actMyApp.setSubmit({ submit: 'get_authorized_apps' }));
    const response = yield call(apiAuthorizedApps.getAuthorizedAppsV1, {
      userId,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      params: { scope_descriptions: true },
    });

    if (hasFeature('moka-connect-jurnal-integration')) {
      const partnerV2Response = yield call(apiPartners.getPartners, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        only_registered: true,
      });
      const listTransformedPartnerDto =
        partnerDTOHelper.convertPartnerDtoListToAppDtoList(
          partnerV2Response.data
        );

      const combinedData: any[] = [];
      combinedData.push(...response.data.data.apps);
      combinedData.push(...listTransformedPartnerDto);

      yield put(actMyApp.setApps({ apps: combinedData }));
    } else {
      yield put(actMyApp.setApps({ apps: response.data.data.apps }));
    }
    const resProfile = yield call(apiProfile.getProfile);
    const profile = resProfile.data;
    yield put(
      actMyApp.setBusiness({
        business: {
          name: profile.business.name,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          outlet_count: profile.user_outlets_id.length,
        },
      })
    );
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(actMyApp.setSubmit({ submit: '' }));
    yield put(hideProgressBar());
  }
}

export function* onConfirmRemoveAppFlow(request) {
  const {
    payload: { app, previousApps, userId },
  } = request;
  try {
    yield put(showProgressBar());

    if (
      hasFeature('moka-connect-jurnal-integration') &&
      app.partner_version === 2
    ) {
      yield call(apiPartners.unregisterMerchantConsent, app.id);
    } else {
      yield call(apiAuthorizedApps.deleteAuthorizedAppsV1, {
        userId,
        appId: app.id,
      });
    }

    const currentApps: any[] = [];
    previousApps.forEach((pApp) => {
      if (app.id !== pApp.id) {
        currentApps.push(pApp);
      }
    });

    yield put(actMyApp.setRemovedApp({ app: {} }));
    yield put(actMyApp.setApps({ apps: currentApps }));
    yield put(actMyApp.hideRemoveAppModal());
    yield put(actNotif.success('App has been successfully removed'));
  } catch (error) {
    yield put(actNotif.error('Something went wrong'));
  } finally {
    yield put(hideProgressBar());
  }
  clevertapOpenPlatformMyApp.myAppRevokeConfirmed({
    uid: app.uid,
    name: app.name,
  });
}

export function* onCancelRemoveAppFlow() {
  yield put(actMyApp.setRemovedApp({ app: {} }));
  yield put(actMyApp.hideRemoveAppModal());
}

export function* onClickRemoveAppFlow(request) {
  const {
    payload: { app },
  } = request;
  try {
    yield put(showProgressBar());
    yield put(actMyApp.setRemovedApp({ app }));
    yield put(actMyApp.showRemoveAppModal());
  } finally {
    yield put(hideProgressBar());
  }
  clevertapOpenPlatformMyApp.myAppRevoke({ uid: app.uid, name: app.name });
}

export function* pageRequestFlow(request) {
  const {
    payload: { userId },
  } = request;
  yield put(actMyApp.listRequest({ userId }));
}

export default function* saga() {
  yield takeLatest(OPEN_PLATFORM_MY_APP_LIST_REQUEST, listRequest);
  yield takeLatest(OPEN_PLATFORM_MY_APP_PAGE_REQUEST, pageRequestFlow);
  yield takeLatest(
    OPEN_PLATFORM_MY_APP_ON_CONFIRM_REMOVE_APP,
    onConfirmRemoveAppFlow
  );
  yield takeLatest(
    OPEN_PLATFORM_MY_APP_ON_CANCEL_REMOVE_APP,
    onCancelRemoveAppFlow
  );
  yield takeLatest(
    OPEN_PLATFORM_MY_APP_ON_CLICK_REMOVE_APP,
    onClickRemoveAppFlow
  );
}
